//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    imageUrl: String,
    caption: String,
    link: String
  }
}
